var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuesaxOutlineEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.753,
    height: 21.753,
    viewBox: "0 0 21.753 21.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_edit",
    "data-name": "vuesax/outline/edit",
    transform: "translate(-621.25 -252.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75,21.5h-6C2.32,21.5,0,19.18,0,13.75v-6C0,2.32,2.32,0,7.75,0h2a.755.755,0,0,1,.75.75.755.755,0,0,1-.75.75h-2C3.14,1.5,1.5,3.14,1.5,7.75v6C1.5,18.36,3.14,20,7.75,20h6C18.36,20,20,18.36,20,13.75v-2a.75.75,0,0,1,1.5,0v2C21.5,19.18,19.18,21.5,13.75,21.5Z",
    transform: "translate(621.25 253.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.2,16.693a2.239,2.239,0,0,1-1.58-.62,2.25,2.25,0,0,1-.59-1.95l.43-3.01a3.468,3.468,0,0,1,.87-1.74l7.88-7.88c1.99-1.99,4.01-1.99,6,0a4.175,4.175,0,0,1,1.48,3.31,4.448,4.448,0,0,1-1.48,2.68l-7.88,7.88a3.468,3.468,0,0,1-1.74.87l-3.01.43A1.668,1.668,0,0,1,2.2,16.693Zm8.07-14.14-7.88,7.88a2.035,2.035,0,0,0-.45.89l-.43,3.01a.785.785,0,0,0,.17.68.785.785,0,0,0,.68.17l3.01-.43a1.983,1.983,0,0,0,.89-.45l7.88-7.88a3.069,3.069,0,0,0,1.04-1.77,2.776,2.776,0,0,0-1.04-2.11C12.539.942,11.439,1.393,10.269,2.553Z",
    transform: "translate(626.301 252.997)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.687,6.447a.645.645,0,0,1-.2-.03A7.937,7.937,0,0,1,.027.957a.76.76,0,0,1,.52-.93.745.745,0,0,1,.92.52,6.425,6.425,0,0,0,4.42,4.42.755.755,0,0,1,.52.93A.736.736,0,0,1,5.687,6.447Z",
    transform: "translate(634.163 255.383)",
    fill: "#061133"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineEdit);
export default __webpack_public_path__ + "static/media/vuesax-outline-edit.7c8313182082729908b6b782e42f456f.svg";
export { ForwardRef as ReactComponent };